// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"iZ-z","tooltip":"jZ-z","tooltipContent":"kZ-z","orderStatusWrapper":"lZ-z"};